import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const fragment = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(fragment);
    const session_id = params.get("session_id");

    if (!session_id) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        // Store the session_token as our Bearer token (ingress strips cookies).
        if (data.session_token) {
          const { setToken } = await import("@/lib/api");
          setToken(data.session_token);
        }
        await refresh();
        navigate(data?.user?.is_seller ? "/seller" : "/explore", { replace: true });
      } catch (err) {
        console.error("Google session failed", err);
        const detail = err.response?.data?.detail || "";
        navigate(`/auth?error=oauth${detail ? `&detail=${encodeURIComponent(detail)}` : ""}`, { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-[var(--paper)]"
    >
      <div className="text-center">
        <div className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--red)]">◆ Signing you in</div>
        <div className="serif text-[28px] mt-2">One second…</div>
      </div>
    </div>
  );
}
